import type { Medicine } from "@interfaces";
import { min as minDate } from "date-fns";

export function getOldestExternalPriceUpdateDate(medicine: Medicine): Date | null {
  const validUpdateDates = (medicine.externalPrices ?? [])
    .map(({ lastUpdate }) => new Date(lastUpdate))
    .filter((date) => !isNaN(date.getTime()));

  if (!validUpdateDates.length) return null;

  return minDate(validUpdateDates);
}
